"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-3d-printing";

const IMAGE_BASE = "/image/new-version/more/3D-Printing/Various-Industries";

const INDUSTRIES = [
	{ keyPrefix: "variousIndustriesAerospace", image: `${IMAGE_BASE}/aerospace.webp`, href: "/industry/aerospace" },
	{ keyPrefix: "variousIndustriesAutomotive", image: `${IMAGE_BASE}/automotive.webp`, href: "/industry/automotive" },
	{
		keyPrefix: "variousIndustriesMedicalDevices",
		image: `${IMAGE_BASE}/medical-devices.webp`,
		href: "/industry/medical-device",
	},
	{ keyPrefix: "variousIndustriesAutomation", image: `${IMAGE_BASE}/automation.webp`, href: "/industry/industry-equipment" },
	{ keyPrefix: "variousIndustriesRobotics", image: `${IMAGE_BASE}/robotics.webp`, href: "/industry/robotics-automation" },
	{
		keyPrefix: "variousIndustriesConsumerProducts",
		image: `${IMAGE_BASE}/consumer-products.webp`,
		href: "/industry/consumer-goods",
	},
] as const;

export default function VariousIndustries() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#f5f7fa] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<span className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.2em] text-themePrimary400 sm:text-sm">
					{t("variousIndustriesLabel")}
				</span>
				<h2 className="mb-4 text-2xl font-bold leading-tight text-black sm:mb-5 sm:text-[30px] md:text-4xl">
					{t("variousIndustriesTitle")}
				</h2>
				<p className="mb-6 text-sm leading-relaxed text-black sm:mb-8 md:text-base">
					{t("variousIndustriesDesc")}
				</p>

				<div className="grid items-start gap-8 lg:grid-cols-[6fr_4fr] lg:gap-12">
					<div className="grid gap-5 sm:grid-cols-2 sm:gap-x-10 sm:gap-y-6">
						{INDUSTRIES.map((item) => (
							<div key={item.keyPrefix}>
								<h3 className="mb-2 text-base font-bold text-themePrimary400 sm:text-lg">
									{t(`${item.keyPrefix}Name`)}
								</h3>
								<p className="text-sm leading-relaxed text-black">{t(`${item.keyPrefix}Desc`)}</p>
							</div>
						))}
					</div>

					<div className="grid w-full grid-cols-2 gap-4 sm:gap-5">
						{INDUSTRIES.map((item) => (
							<Link
								key={item.keyPrefix}
								href={item.href}
								className="group relative block overflow-hidden rounded-2xl bg-[#f0f0f0] aspect-[4/2.7] p-4 transition-colors duration-300 hover:bg-[#8bc34a] hover:shadow-md"
							>
								<div className="relative h-[40%] w-[40%]">
									<div className="relative aspect-square overflow-hidden rounded-full">
										<Image src={item.image} alt={t(`${item.keyPrefix}Alt`)} fill className="object-contain" />
									</div>
								</div>
								<h4 className="absolute bottom-4 right-4 text-sm font-bold text-black transition-colors duration-300 group-hover:text-white sm:text-base">
									{t(`${item.keyPrefix}Name`)}
								</h4>
							</Link>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
